import type { ContentFormat } from "../../services/educationService";

/**
 * Map a ContentFormat to its route segment under /education/:id/.
 * Every format now has a dedicated viewer; `text` is the default.
 */
export function formatToSegment(format: ContentFormat): string {
	switch (format) {
		case "audio":
			return "podcast";
		case "cards":
			return "cards";
		case "video":
			return "video";
		default:
			return "article";
	}
}
